export interface ResultRow {
  id: number | string;
  media: string | number;
  reference_value: string | number;
  variation: string | number;
  result: string | number;
  value_to_apply: string | number;
}
export const initialRowsResult: ResultRow[] = [
  {
    id: "NEW_1",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
  {
    id: "NEW_2",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
  {
    id: "NEW_3",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
  {
    id: "NEW_4",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
  {
    id: "NEW_5",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
  {
    id: "NEW_6",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
  {
    id: "NEW_7",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
  {
    id: "NEW_8",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
  {
    id: "NEW_9",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
  {
    id: "NEW_10",
    media: 0,
    reference_value: 0,
    variation: 0,
    result: 0,
    value_to_apply: 0,
  },
];
